var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:[
    'BaseCapability',
    { included: _vm.included },
  ],attrs:{"to":_vm.to}},[(_vm.icon)?_c('i',{key:_vm.icon,staticClass:"BaseCapability_icon",class:_vm.icon}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }